import { createAsyncThunk, createSlice } from "@reduxjs/toolkit";
import axiosInstance from "../axiosInstance";
import { toastService } from "../../utils/toastify";

//
export const getChallenges = createAsyncThunk(
  "challenges/get",
  async (payload, { rejectWithValue }) => {
    try {
      const response = await axiosInstance.get("challengeList", {
        params: payload,
      });
      return response.data;
    } catch (error) {
      console.log(error);
      rejectWithValue(error);
    }
  }
);
export const addChallenges = createAsyncThunk(
  "challenges/add",
  async (payload, { rejectWithValue }) => {
    try {
      const response = await axiosInstance.post("addChallenge", payload);
      return response.data;
    } catch (error) {
      console.log({ error });
            if (error?.response?.data?.code == 403) {
              toastService.error(error?.response?.data?.message);
              rejectWithValue(error);
            } else {
              toastService.error("Challanges added failed");
              rejectWithValue(error);
            }
    }
  }
);
export const editChallenges = createAsyncThunk(
  "challenges/edit",
  async (payload, { rejectWithValue }) => {
    try {
      const response = await axiosInstance.put("editChallenge", payload);
      return response.data;
    } catch (error) {
      console.log(error);
      rejectWithValue(error);
    }
  }
);
export const challengesStatus = createAsyncThunk(
  "challenges/statusChanged",
  async (payload, { rejectWithValue }) => {
    try {
      const response = await axiosInstance.patch(
        "challengeStatusChanged",
        payload
      );
      return response.data;
    } catch (error) {
      console.log(error);
      rejectWithValue(error);
    }
  }
);
export const getPrizeList = createAsyncThunk(
  "get/prizeList",
  async (payload, { rejectWithValue }) => {
    try {
      const response = await axiosInstance.get("prizeList", {
        params: payload,
      });
      return response.data;
    } catch (error) {
      console.log(error);
      rejectWithValue(error);
    }
  }
);
export const addPrize = createAsyncThunk(
  "add/prize",
  async (payload, { rejectWithValue }) => {
    try {
      const response = await axiosInstance.post("addPrize", payload);
      return response.data;
    } catch (error) {
      console.log(error);
      rejectWithValue(error);
    }
  }
);
export const editPrize = createAsyncThunk(
  "edit/prize",
  async (payload, { rejectWithValue }) => {
    try {
      const response = await axiosInstance.put("editPrize", payload);
      return response.data;
    } catch (error) {
      console.log(error);
      rejectWithValue(error);
    }
  }
);
export const getSubmissionList = createAsyncThunk(
  "get/submissionList",
  async (payload, { rejectWithValue }) => {
    try {
      const response = await axiosInstance.get("submissionList", {
        params: payload,
      });
      return response.data;
    } catch (error) {
      console.log(error);
      rejectWithValue(error);
    }
  }
);
export const addRankPoint = createAsyncThunk(
  "add/rankPoint",
  async (payload, { rejectWithValue }) => {
    try {
      const response = await axiosInstance.post("addRankAndPoints", payload);
      return response.data;
    } catch (error) {
      console.log(error);
      rejectWithValue(error);
    }
  }
);
export const getLeaderBoardList = createAsyncThunk(
  "get/leaderBoard",
  async (payload, { rejectWithValue }) => {
    try {
      const response = await axiosInstance.get("leaderBoardList", {
        params: payload,
      });
      return response.data;
    } catch (error) {
      console.log(error);
      rejectWithValue(error);
    }
  }
);
export const addWinnerList = createAsyncThunk(
  "add/winnerlist",
  async (payload, { rejectWithValue }) => {
    try {
      const response = await axiosInstance.post("addWinner", payload);
      return response.data;
    } catch (error) {
      console.log(error);
      rejectWithValue(error);
    }
  }
);
export const getWinnerList = createAsyncThunk(
  "get/winnerlist",
  async (payload, { rejectWithValue }) => {
    try {
      const response = await axiosInstance.get("winnerList", {
        params: payload,
      });
      return response.data;
    } catch (error) {
      console.log(error);
      rejectWithValue(error);
    }
  }
);
export const removeWinnerList = createAsyncThunk(
  "remove/winnerlist",
  async (payload, { rejectWithValue }) => {
    try {
      const response = await axiosInstance.post(
        "removeFromWinnerList",
        payload
      );
      return response.data;
    } catch (error) {
      console.log(error);
      rejectWithValue(error);
    }
  }
);
export const publishWinnerList = createAsyncThunk(
  "publish/winnerlist",
  async (payload, { rejectWithValue }) => {
    try {
      const response = await axiosInstance.post("publishWinnerList", payload);
      return response.data;
    } catch (error) {
      console.log(error);
      rejectWithValue(error);
    }
  }
);
export const getSubmitSubmissionList = createAsyncThunk(
  "get/submissionWinnerList",
  async (payload, { rejectWithValue }) => {
    try {
      const response = await axiosInstance.get("submissionWinnerList", {
        params: payload,
      });
      return response.data;
    } catch (error) {
      console.log(error);
      rejectWithValue(error);
    }
  }
);
const challenges = createSlice({
  name: "challenges",
  initialState: {
    loading: false,
    challenges: [],
    submissionList: [],
    prizeList: [],
    leaderboard: [],
    winnerList: [],
    submissionWinnerList: [],
    activeTab: "",
  },
  extraReducers: (builder) => {
    builder.addCase(getChallenges.pending, (state) => {
      state.loading = true;
    });
    builder.addCase(getChallenges.fulfilled, (state, action) => {
      state.loading = false;
      state.challenges = action.payload;
    });
    builder.addCase(getChallenges.rejected, (state, action) => {
      state.loading = false;
      console.log(action.payload);
    });
    builder.addCase(getPrizeList.pending, (state, action) => {
      state.loading = true;
    });
    builder.addCase(getPrizeList.fulfilled, (state, action) => {
      state.loading = false;
      state.prizeList = action.payload;
    });
    builder.addCase(getPrizeList.rejected, (state, action) => {
      state.loading = false;
      console.log(action.payload);
    });
    builder.addCase(getSubmissionList.pending, (state, action) => {
      state.loading = true;
    });
    builder.addCase(getSubmissionList.fulfilled, (state, action) => {
      state.loading = false;
      state.submissionList = action.payload;
    });
    builder.addCase(getSubmissionList.rejected, (state, action) => {
      state.loading = false;
      console.log(action.payload);
    });
    builder.addCase(getLeaderBoardList.pending, (state, action) => {
      state.loading = true;
    });
    builder.addCase(getLeaderBoardList.fulfilled, (state, action) => {
      state.loading = false;
      state.leaderboard = action.payload;
    });
    builder.addCase(getLeaderBoardList.rejected, (state, action) => {
      state.loading = false;
      console.log(action.payload);
    });
    builder.addCase(getWinnerList.pending, (state, action) => {
      state.loading = true;
    });
    builder.addCase(getWinnerList.fulfilled, (state, action) => {
      state.loading = false;
      state.winnerList = action.payload;
    });
    builder.addCase(getWinnerList.rejected, (state, action) => {
      state.loading = false;
      console.log(action.payload);
    });
    builder.addCase(getSubmitSubmissionList.pending, (state, action) => {
      state.loading = true;
    });
    builder.addCase(getSubmitSubmissionList.fulfilled, (state, action) => {
      state.loading = false;
      state.submissionWinnerList = action.payload;
    });
    builder.addCase(getSubmitSubmissionList.rejected, (state, action) => {
      state.loading = false;
      console.log(action.payload);
    });
  },
  reducers: {
    activeTabFunc: (state, action) => {
      state.activeTab = action.payload;
    },
  },
});
export const { activeTabFunc } = challenges.actions;
export default challenges.reducer;
